import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { RealtyImage } from 'shared/api/kyrgyzstan/search'
import { AppAdviceText } from 'shared/ui/app-advice-text'
import { HeaderGoBack } from 'shared/ui/header-go-back'
import { ImageGallerySlider } from 'shared/ui/image-gallery-slider'
import { Loader } from 'shared/ui/loader'

import s from './styles.module.scss'

interface ImageGalleryWrapperProps {
  images: RealtyImage[]
  title: string
  initialIndex: number
  isLoading: boolean
  error: string | null
}

export const ImageGalleryWrapper = ({
  images,
  title,
  initialIndex,
  isLoading,
  error,
}: ImageGalleryWrapperProps) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const handleGoBack = () => {
    navigate(-1)
  }

  if (isLoading) {
    return (
      <div className="container">
        <HeaderGoBack
          onGoBack={handleGoBack}
          variant="grey"
          buttonWhite
        />

        <div className={s.loader}>
          <Loader />
          <AppAdviceText />
        </div>
      </div>
    )
  }

  if (error || !images || images.length === 0) {
    return (
      <div className="container">
        <HeaderGoBack
          onGoBack={handleGoBack}
          variant="grey"
          buttonWhite
        />
        <div className={s.error}>
          <p>{error || t('kyrgyzstan_block.error.title')}</p>
        </div>
      </div>
    )
  }

  return (
    <div className={s.container}>
      <HeaderGoBack
        title={title}
        onGoBack={handleGoBack}
        variant="grey"
        buttonWhite
      />

      <ImageGallerySlider
        images={images}
        initialIndex={initialIndex}
      />
    </div>
  )
}
